import type { IDictionaryIndustry } from '@/creditflowresearch/domain/vo/IDictionary';
import type { IFilterBoundaryIndustry } from '@/creditflowresearch/domain/vo/Bondscreener';

export interface ISubindustryNode {
  id: string,
  name: string,
  disabled: boolean,
  marketSegmentId: string | null,
}

export interface IIndustryNode {
  id: string,
  name: string,
  children: ISubindustryNode[],
}

export interface IIndustryNodeWithCounts extends IIndustryNode {
  enabledIds: string[],
  allIds: string[],
  selectedCount: number,
  totalSelectedCount: number,
}

const buildIndustryTree = (
  industries: IDictionaryIndustry[],
  boundaryIndustries: IFilterBoundaryIndustry[],
): IIndustryNode[] => {
  const subindustryIdsWithData = new Set(
    boundaryIndustries.flatMap((b) => b.subindustryIds),
  );

  return industries.map((industry) => ({
    id: industry.id,
    name: industry.name,
    children: industry.subindustries.map((sub) => ({
      id: sub.id,
      name: sub.name,
      disabled: !subindustryIdsWithData.has(sub.id),
      marketSegmentId: sub.marketSegmentId,
    })),
  }));
};

export default buildIndustryTree;
